import { useTranslation } from "react-i18next";

const COOKIE_NAME = "eduardoCookieConsent";

export default function CookieConsentModal({ visible, onOpenLegal, onClose }) {
  const { t } = useTranslation();

const accept = () => {
  localStorage.setItem(COOKIE_NAME, "accepted");

  window.gtag('consent', 'update', {
    ad_storage: 'granted',
    analytics_storage: 'granted',
    functionality_storage: 'granted',
    personalization_storage: 'granted',
    security_storage: 'granted'
  });

  window.dataLayer.push({
    event: 'cookie_consent_granted',
    ad_storage: 'granted',
    analytics_storage: 'granted',
    functionality_storage: 'granted',
    personalization_storage: 'granted',
    security_storage: 'granted'
  });

  onClose();
};

const decline = () => {
  localStorage.setItem(COOKIE_NAME, "declined");

  window.gtag('consent', 'update', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'granted' 
  });

  window.dataLayer.push({
    event: 'cookie_consent_declined',
    ad_storage: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'granted'
  });

  onClose();
};


  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-background-light dark:bg-background-dark rounded-lg p-6 max-w-md mx-4 text-center shadow-lg">
        <p className="mb-4 text-gray-900 dark:text-gray-100">
          {t(
            "cookieConsent.message",
            "This website uses cookies to enhance your experience and analyse traffic via Google Analytics."
          )}
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={accept}
                       className="action-success px-4 py-2 border border-gray-400 rounded transition"
          >
            {t("cookieConsent.accept", "Accept")}
          </button>
          <button
            onClick={decline}
            className="action-button px-4 py-2 border border-gray-400 rounded transition"
          >
            {t("cookieConsent.decline", "Decline")}
          </button>
        </div>
        <div className="mt-4 text-sm text-gray-500 dark:text-gray-400">
          <span
            onClick={e => {
              e.preventDefault();
              onOpenLegal();
            }}
            className="underline text-zinc-500 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100"
            role="button" 
            tabIndex="0"
          >
            {t("cookieConsent.learnMore", "Learn more")}
          </span>
        </div>
      </div>
    </div>
  );
}
